function r(r){return r<-256?0:(r=1+r/256,r*=r,r*=r,r*=r,r*=r,r*=r,r*=r,r*=r,r*=r)}function e(r,e){var f;if(e>0){f=r;for(var n=1;n<e;n++)f*=r}else if(e<0){f=1/r;for(n=-1;n>e;n--)f/=r}else f=1;return f}export{r as fastExp,e as fastPow};
